DialogsService.$inject = ['dialogService'];
export default function DialogsService(dialogService) {

    var TAG = 'InformeActionsService: ';

    var DIALOG_SELECT_TEMPLATE = require('./select/dialog-select.html');
    var DIALOG_SELECT_ID = 'dialog-select';
    var DIALOG_DATE_TEMPLATE = require('./date/dialog-date.html');
    var DIALOG_DATE_ID = 'dialog-date';

    return {
        select: function (opcionesDialogo) {
            var options = {}; //TODO: Cambiar
            if (typeof opcionesDialogo.titulo !== 'undefined')
                options.title = opcionesDialogo.titulo;
            var datos = {
                promesaDatos: opcionesDialogo.promesaDatos,
                callbackSubmit: opcionesDialogo.callbackSubmit,
                propiedadLabel: opcionesDialogo.propiedadLabel,
                descripcion: opcionesDialogo.descripcion
            };
            var opcionesExtra = {deshabilitarBotones: true};

            return dialogService.open(DIALOG_SELECT_ID, DIALOG_SELECT_TEMPLATE, datos, options, opcionesExtra);
        },
        date: function (opcionesDialogo) {
            var options = {};
            if (typeof opcionesDialogo.titulo !== 'undefined')
                options.title = opcionesDialogo.titulo;
            var datos = {
                callbackSubmit: opcionesDialogo.callbackSubmit,
                descripcion: opcionesDialogo.descripcion,
                mensaje: opcionesDialogo.mensaje,
                label: opcionesDialogo.label,
                modelo: opcionesDialogo.modelo
            };
            var opcionesExtra = {deshabilitarBotones: true, devolverDatos: true};

            return dialogService.open(DIALOG_DATE_ID, DIALOG_DATE_TEMPLATE, datos, options, opcionesExtra);
        }
    }
}